import React from "react";
import book from "../assets/Academy/book.webp";
import timer from "../assets/Academy/timer.webp";
import profile from "../assets/Academy/profile-tick.webp";
import note from "../assets/Academy/note.webp";
import flash from "../assets/Academy/flash.webp";
import monitor from "../assets/Academy/monitor.webp";
import dollar from "../assets/Academy/dollar.webp";
import people from "../assets/Academy/people.webp";

const AcademySection2 = ({ academy }) => {

  const academyItems = [
    { key: "academyselfplaced", icon: book, alt: "Self-paced" },
    { key: "academymonth", icon: timer, alt: "Duration" },
    { key: "academymentor", icon: profile, alt: "Mentorship" },
    { key: "academyprerequisites", icon: note, alt: "Prerequisites" },
    { key: "academyprogram", icon: flash, alt: "Program" },
    { key: "academyproject", icon: monitor, alt: "Project" },
    { key: "academylearning", icon: people, alt: "People" },
    { key: "academypayment", icon: dollar, alt: "dollar" },
  ];


  const filteredItems = academyItems.filter(
    (item) => academy[item.key] !== null
  );

  return (
    <section className="bg-white py-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-5xl ">
          <div className="grid grid-cols-2 md:grid-cols-4 2xl:grid-cols-4 gap-6">
            {filteredItems.map((item, index) => {
     
              const isLastCentered = 
                filteredItems.length === 5 && 
                index === filteredItems.length - 1;
              
              return (
                <div 
                  key={item.key}
                  className={`flex items-start ${
                    isLastCentered ? "md:col-span-1 md:justify-center" : ""
                  }`}
                >
                  <img
                    src={item.icon}
                    alt={item.alt}
                    className="w-5 h-5 object-contain opacity-60"
                  />
                  <div>
                    <p className="text-gray-600 ml-4 text-wrap">
                      {academy[item.key]}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AcademySection2;